import React from 'react'
import { useLocalisation } from '@3plearning/lingui-cdn';

import DueDateInfoIcon from './components/due-date-info-icon'
import getTranslations from './translations'
import {
  InfoTooltip,
  InfoTooltipText,
  InfoIcon
} from './styled';

const DueDateInfo = () => {
  const { i18n } = useLocalisation();

  const { DUE_DATE_INFO } = getTranslations({i18n});

  return(
    <InfoIcon>
      <DueDateInfoIcon />
      <InfoTooltip>
        <InfoTooltipText>{DUE_DATE_INFO}</InfoTooltipText>
      </InfoTooltip>
    </InfoIcon>
  )
}

export default DueDateInfo;


// WEBPACK FOOTER //
// ./components/current-assignment-modal/assign-list/assignment/components/due-date-info/due-date-info.js